export default __webpack_public_path__ + "static/media/administrator-blue.b5d79f3c.svg";